import React from "react";
import { useState } from "react";
import SignUpPopUp2 from "./SignUpPopUp2";

const SubscribeNow = () => {
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);

    const handleButtonClick = () => {
        setIsPopUpVisible(true);
    };

    const handleClosePopUp = () => {
        setIsPopUpVisible(false);
    };

    return (
        <div>
            <section id="subscribe-now" className="flex flex-col items-center justify-between p-4 m-4 md:p-8 md:m-8 text-primary_text">
                <h1 className="text-2xl md:text-4xl font-bold text-center mb-0 animate-slideInFromAbove">
                    <strong className="text-gradient-ai">Subscribe</strong> Now
                </h1>
            </section>

            <section className="flex flex-col md2:flex-row items-center justify-between p-0 m-4 md:m-8 gap-4 md:rounded-xl text-primary_text">
                <div className="flex items-center justify-center md:p-0 md2:p-2 lg1:p-10 w-full xmd2:w-2/3 md:w-1/3 animate-spinLeft">
                    <div className="flex flex-col items-center justify-between w-full h-[450px] md:h-[500px] p-4 bg-white rounded-2xl md:rounded-3xl text-black cursor-pointer md:hover:scale-105 transition">
                        <div className="flex flex-col items-center space-y-3 justify-between">
                            <h1 className="text-2xl md:text-3xl font-bold">Plan 1</h1>
                            <h1 className="background-gradient-ai_1 w-[120px] md:w-[150px] h-auto md:h-[50px] text-ld md:text-2xl font-light rounded-full">Free</h1>
                            <p className="text-white">*</p>
                        </div>
                        <hr className="w-full border border-bgBlackLevel1 border-1 rounded-full" />
                        <div className="flex flex-col w-full h-3/5 items-center space-y-2 justify-around">
                            <ul className="list-disc list-inside text-left space-y-1">
                                <li>10 Free Sessions</li>
                                <li>Access to full suite of features</li>
                            </ul>
                            <button
                                type="button"
                                onClick={handleButtonClick}
                                className="button-gradient-ai_2"
                            >
                                SignUp Now!
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-center md:p-0 md2:p-2 lg1:p-10 w-full xmd2:w-2/3 md:w-1/3 animate-spinLeft">
                    <div className="flex flex-col items-center justify-between w-full h-[450px] md:h-[500px] p-4 bg-white rounded-2xl md:rounded-3xl text-black cursor-pointer md:hover:scale-105 transition">
                        <div className="flex flex-col items-center space-y-3 justify-between">
                            <h1 className="text-2xl md:text-3xl font-bold">Plan 2</h1>
                            <h1 className="background-gradient-ai_1 w-[120px] md:w-[150px] h-auto md:h-[50px] text-ld md:text-2xl font-light rounded-full">$89/Month</h1>
                            <p className="">*Billed Anually</p>
                        </div>
                        <hr className="w-full border border-bgBlackLevel1  border-1 rounded-full" />
                        <div className="flex flex-col w-full h-3/5 items-center space-y-2 justify-around">
                            <ul className="list-disc list-inside text-left space-y-1">
                                <li>Unlimited Sessions</li>
                                <li>Integration with your EMR/EHR</li>
                                <li>Access to all features available</li>
                            </ul>
                            <button
                                type="button"
                                onClick={handleButtonClick}
                                className="button-gradient-ai_2"
                            >
                                SignUp Now!
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-center md:p-0 md2:p2 lg1:p-10 w-full xmd2:w-2/3 md:w-1/3 animate-spinLeft">
                    <div className="flex flex-col items-center justify-between w-full h-[600px] sm1:h-[450px] md:h-[500px] p-4 bg-white rounded-2xl md:rounded-3xl text-black cursor-pointer md:hover:scale-105 transition">
                        <div className="flex flex-col items-center space-y-3 justify-between">
                            <h1 className="text-2xl md:text-3xl font-bold">Plan 3</h1>
                            <h1 className="background-gradient-ai_1 w-[120px] md:w-[150px] h-auto md:h-[50px] text-ld md:text-2xl font-light rounded-full">Enterprise</h1>
                            <p className="">*Billed Anually</p>
                        </div>
                        <hr className="w-full border border-bgBlackLevel1  border-1 rounded-full" />
                        <div className="flex flex-col w-full h-3/5 items-center space-y-2 justify-around">
                            <ul className="list-disc list-inside text-left space-y-1">
                                <li>For practices with more than 5 practitioners</li>
                                <li>Unlimited Sessions</li>
                                <li>Integration with your EMR/EHR</li>
                                <li>Access to all features available</li>
                                {/* <li>Telemedicine Capabilities and other features</li> */}
                            </ul>
                            {/* <p className="text-[12px] text-red-500">* To subscribe to this plan, contact our <a href="mailto:sales" className="text-blue-500 hover:underline">sales</a> team.</p> */}
                            {/* <p className="text-[12px] text-red-500">* To subscribe to this plan, contact our sales team.</p> */}
                            <p className="text-[12px] text-red-500">* Contact sales to make a plan tailored to your needs</p>
                            <button
                                type="button"
                                // onClick={handleButtonClick}
                                className="button-gradient-ai_2"
                            >
                                <a href="mailto:sales@tibb.io">Contact Sales</a>
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="w-full flex items-center justify-between p-0 md:mb-8 text-primary_text">
                <div className="flex items-center justify-center p-8 md:p-4 w-full">
                    <p className="text-white text-xl font-serif">
                        To avail our current promotions, contact our <a href="mailto:sales@tibb.io" className="text-blue-400 hover:underline">Sales</a> team.
                    </p>
                </div>
            </section>

            <SignUpPopUp2 show={isPopUpVisible} onClose={handleClosePopUp} />
        </div>
    );
};

export default SubscribeNow;
